// Shared service/trade catalog — homepage search aur booking flow dono use karenge.

export const HIPAGES_SERVICE_SLUGS = [
  "air_conditioner_cleaning", "air_conditioning", "air_conditioning_repairs_and_maintenance", "all",
  "antenna_services", "appliance_installation", "appliance_repairs", "arborists", "architects",
  "architectural_town_planning_services", "asbestos_removal", "awning_suppliers", "awnings",
  "balustrades", "bamboo_flooring", "bath_resurfacing", "bathroom_accessories", "bathroom_renovations",
  "bathroom_stripout", "blinds", "bricklayers", "builders", "building_certifiers", "building_consultants",
  "building_designers", "building_suppliers", "building_surveyors", "cabinet_makers", "carpenters",
  "carpet_cleaning", "carpet_layers", "carpets", "carports", "ceilings", "chimney_sweepers", "cladding",
  "cleaning_services", "commercial_cleaning", "concrete_driveways", "concrete_kerbs", "concrete_resurfacing",
  "concretors", "construction_project_management", "curtains", "custom_furniture", "damp_proofing",
  "decking", "decking_repairs", "deep_cleaning", "demolition", "dishwasher_appliance_repairs",
  "door_repairs", "door_suppliers", "doors", "drafters", "electricians", "equipment_hire",
  "ev_charger_installation", "excavation", "fence_repairs", "fences", "fences_general_contractor",
  "fences_timber", "floor_coatings", "floor_sanding", "flyscreen_repairs", "flyscreens",
  "foxtel_and_tv_and_satellite_antenna_services", "funiture_chair", "furniture_removal",
  "furniture_removal_small_move", "garage_door_repairs", "garages", "garden_designer", "garden_maintenance",
  "garden_maintenance_garden_cleanup", "gas_fitters", "gates", "gates_automatic_gates", "gazebo",
  "glass_glazier", "glass_glazier_glass_cutting", "granny_flats", "gutter_cleaning", "gutter_replacement",
  "guttering", "guttering_repairs", "handrails", "heaters", "heating_systems",
  "heating_systems_underfloor_heating", "home_automation", "home_renovations", "home_theatre", "homewares",
  "hot_water_systems", "hybrid_flooring", "inspection_services", "inspections_prepurchase_property_inspections",
  "insulation", "interior_decorator", "interior_designer", "interior_designer_kitchen_design",
  "irrigation_systems", "irrigation_systems_irrigation_repairs", "joiners", "kitchen_benchtops",
  "kitchen_cabinet_makers", "kitchen_renovations", "kitchen_resurfacing", "landscape_architect",
  "landscaper_gardener", "lawn_mowing", "lawn_turf", "lawn_turf_synthetic_turf_supply_and_install",
  "leak_detection", "lighting", "locksmiths", "locksmiths_key_cutting", "mattress_cleaning",
  "oven_and_range_hood_repairs", "painters", "patios", "patios_repairs", "paver", "pergola",
  "pest_control", "pest_control_possums", "pest_inspections", "plaster_repairs", "plastering", "plumbers",
  "pool_fencing", "pool_heating", "pool_maintenance", "pool_maintenance_pool_cleaning_service", "pools",
  "pressure_cleaner", "privacy_screens", "professional_organisers", "refrigerator_repairs", "render",
  "renderer", "rental_bond_cleaning", "retaining_walls", "roller_shutters", "roof_insulation",
  "roof_repairs", "roofing", "rubbish_remover", "rubbish_remover_skip_and_bin_hire", "scaffolding",
  "security", "security_screen_door_repairs", "security_screens_doors", "shades_sails", "sheds",
  "sheds_shed_builders", "shop_fitters", "shower_screens", "skip_truck_hire", "skylights", "soil_testing",
  "solar_panel_cleaners", "solar_power", "splashbacks", "stained_glass", "staircases_handrails",
  "stonemasons", "storage", "structural_engineer", "supply_and_install_gates", "surveyor", "tilers",
  "timber_flooring", "timber_flooring_timber_floor_repairs", "tree_fellers", "underpinning",
  "upholstery_repair", "ventilation", "verandahs", "vinyl_laminate", "wallpaperers", "wardrobes",
  "wardrobes_built_in_wardrobe_builders", "washing_machine_repairs", "waterproofers", "window_cleaners",
  "window_repairs", "window_shutters", "window_tinting", "windows", "wire_fencing"
];

export function formatServiceLabel(slug: string) {
  return slug
    .split("_")
    .map((word) => (word.length <= 2 ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(" ");
}

export interface ServiceItem {
  id: string;
  label: string;
  description: string;
}

const MAIN_CATEGORIES: ServiceItem[] = [
  { id: "plumbing", label: "Plumbing", description: "Leaky pipes, taps, toilets & hot water" },
  { id: "electrical", label: "Electrical", description: "Lights, powerpoints, safety & appliances" },
  { id: "flooring", label: "Carpet & Flooring", description: "Carpet, timber, vinyl & tiles" },
  { id: "painting", label: "Painting", description: "Interior, exterior, fences & prep" },
  { id: "handyman", label: "Handyman", description: "Assembly, wall mounting & basic repairs" },
  { id: "cleaning", label: "Cleaning", description: "End of lease, deep clean & domestic" },
  { id: "gardening", label: "Gardening & Yard", description: "Mowing, weeding, lopping & gutters" },
  { id: "tiling", label: "Tiling", description: "Splashbacks, bathrooms & flooring" },
  { id: "hvac", label: "Air Conditioning", description: "Repairs, servicing & installation" },
  { id: "other", label: "Other Trade", description: "Custom jobs & generic repairs" },
];

const HIPAGES_SERVICES: ServiceItem[] = HIPAGES_SERVICE_SLUGS.map((slug) => {
  const label = formatServiceLabel(slug);
  return { id: slug, label, description: `${label} service` };
});

// Pura combined list — yahi hero dropdown filter karega.
export const ALL_SERVICES: ServiceItem[] = [...MAIN_CATEGORIES, ...HIPAGES_SERVICES];